import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ElementiStrutturaliL1SectionWrapper,
  InspectionInfoForm,
} from 'components';
import { CDAOptions, tipologiaArcoOptions } from 'constants/selectOptions';
import useTabellaRiepilogativa from 'hooks/inspections/useTabellaRiepilogativa';
import { INFO } from 'pages/Inspections/config/info';
import { calculateDifettositaComplessiva } from 'pages/Inspections/CreateInspection/utils/extractDefectivenessInfo';
import ArchiForm from './ArchiForm';
const ArchiSection = ({ selectedIdx }) => {
  const { recalculateTable } = useTabellaRiepilogativa();
  const { watch, setValue, getValues } = useFormContext();

  const mensoleTamponiCampateImpalcatoTableArchiTableWatch = watch(
    `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable`
  );

  const mensoleTamponiCampateImpalcatoTable = watch(
    `mensoleTamponiCampateImpalcatoTable`
  );
  //console.log(spallePileCollegamentiTable, 'spallePileCollegamentiTable');

  const mensoleTamponiCampateToCopy = mensoleTamponiCampateImpalcatoTable?.map(
    el => el.archiTable
  );

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();
  const [openSchedaDifetti, setOpenSchedaDifetti] = useState(false);
  const [schedaDifettiIndex, setSchedaDifettiIndex] = useState();

  const editRowsArchi = item => {
    setValue('archiTableValue', [item]);
    setValue('tipologiaArcoTableValue', item.tipologiaArco);
  };

  const handleSelectAllClickArchi = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable`
      );
      setSelected(selectedValue);
      setValue('archiTableValue', selectedValue);
    } else {
      setSelected([]);
      setValue('archiTableValue', []);
    }
  };

  useEffect(() => {
    setValue(
      'l1t2a4_tecnicoRilevatoreArchi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].tecnicoRilevatore`
      ) ||
        getValues('rilevatoreRischioStrutturale') ||
        ''
    );
    setValue(
      'l1t2a4_dataIspezioneArchi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].dataIspezione`
      ) ||
        getValues('dataIspezioneRischioStrutturale') ||
        null
    );
    setValue(
      'l1t2a4_elementoCriticoStrutturaArchi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].elementoCriticoStruttura`
      ) || ''
    );
    setValue(
      'l1t2a4_elementoCriticoSismicaArchi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].elementoCriticoSismica`
      ) || ''
    );
    setValue(
      'l1t2a4_condizioneCriticaStrutturaArchi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].condizioneCriticaStruttura`
      ) || ''
    );
    setValue(
      'l1t2a4_condizioneCriticaSismicaArchi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].condizioneCriticaSismica`
      ) || ''
    );
    setValue(
      'l1t2a4_noteGeneraliArchi',
      getValues(
        `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].noteGenerali`
      ) || ''
    );
  }, [schedaDifettiIndex]);

  const handleSaveInspection = () => {
    const tecnicoRilevatore = getValues('l1t2a4_tecnicoRilevatoreArchi');
    const dataIspezione = getValues('l1t2a4_dataIspezioneArchi');
    const elementoCriticoStruttura = getValues(
      'l1t2a4_elementoCriticoStrutturaArchi'
    );
    const elementoCriticoSismica = getValues(
      'l1t2a4_elementoCriticoSismicaArchi'
    );
    const condizioneCriticaStruttura = getValues(
      'l1t2a4_condizioneCriticaStrutturaArchi'
    );
    const condizioneCriticaSismica = getValues(
      'l1t2a4_condizioneCriticaSismicaArchi'
    );
    const noteGenerali = getValues('l1t2a4_noteGeneraliArchi');
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].tecnicoRilevatore`,
      tecnicoRilevatore
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].dataIspezione`,
      dataIspezione
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].elementoCriticoStruttura`,
      elementoCriticoStruttura
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].elementoCriticoSismica`,
      elementoCriticoSismica
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].condizioneCriticaStruttura`,
      condizioneCriticaStruttura
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].condizioneCriticaSismica`,
      condizioneCriticaSismica
    );
    setValue(
      `mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable[${schedaDifettiIndex}].noteGenerali`,
      noteGenerali
    );
    setValue('l1t2a5_trigger', Math.random() * 1000);
    setTimeout(() => {
      recalculateTable();
    }, 0);

    // Gestione calcolo difettosità complessiva nella tabella riepilogativa
    const tableWatch = getValues('riepilogoStrutturaTable');
    const difettositaStrutturaleEffettiva = watch(
      'arbitraryStructuralFoundationalDefectiveness'
    );
    const difettositaSismicaEffettiva = watch('arbitrarySeismicDefectiveness');
    const tabellaRiepilogativa = tableWatch.filter(
      row => row.codice !== 'Difettosità complessiva'
    );
    const { difettositaStrutturale, difettositaSismica } =
      calculateDifettositaComplessiva(tabellaRiepilogativa);
    const updatedTable = tableWatch.map(row => {
      if (row.codice === 'Difettosità complessiva') {
        return {
          ...row,
          difettositaStrutturale,
          difettositaSismica,
        };
      }
      return row;
    });
    setValue('riepilogoStrutturaTable', updatedTable);
    !difettositaStrutturaleEffettiva &&
      setValue(
        'arbitraryStructuralFoundationalDefectiveness',
        difettositaStrutturale
      );
    !difettositaSismicaEffettiva &&
      setValue('arbitrarySeismicDefectiveness', difettositaSismica);
  };

  const handleResetInspection = () => {
    setValue(`l1t2a4_tecnicoRilevatoreArchi`, '');
    setValue(`l1t2a4_dataIspezioneArchi`, null);
    setValue(`l1t2a4_elementoCriticoStrutturaArchi`, '');
    setValue(`l1t2a4_elementoCriticoSismicaArchi`, '');
    setValue(`l1t2a4_condizioneCriticaStrutturaArchi`, '');
    setValue(`l1t2a4_condizioneCriticaSismicaArchi`, '');
    setValue(`l1t2a4_noteGeneraliArchi`, '');
  };

  const dataArchiConfig = {
    columns: {
      codice: { label: 'Cod.' },
      tipologiaArco: {
        label: 'Tipologia',
        format: tipologiaArcoOptions,
      },
      completamentoSchedaDifetti: { label: 'Completamento Scheda' },
      indiceCondizione: { label: 'Indice di condizione' },
      CDAstrutturale: { label: 'Difettosità Str.', format: CDAOptions },
      CDAsismica: { label: 'Difettosità Sis.', format: CDAOptions },
      nrtotali: { label: 'NR' },
      g5totali: { label: 'G=5' },
      pstotali: { label: 'PS' },
    },
  };

  const copyTableConfig = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaArco: {
        label: 'Tipologia',
        format: tipologiaArcoOptions,
      },
    },
  };

  const mensoleTamponiCampateImpalcatoSelezione = watch(
    'mensoleTamponiCampateImpalcatoSelezione'
  );

  useEffect(() => {
    if (mensoleTamponiCampateImpalcatoSelezione) {
      setSchedaDifettiIndex(undefined);
      setOpenSchedaDifetti(false);
    }
  }, [mensoleTamponiCampateImpalcatoSelezione]);

  useEffect(() => {
    if (schedaDifettiIndex !== undefined) {
      setOpenSchedaDifetti(true);
    }
  }, [schedaDifettiIndex]);

  return (
    <>
      <ElementiStrutturaliL1SectionWrapper
        selectedIdx={selectedIdx}
        elementTitle={'archi'}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoArchi.drawerTitle}
        drawerText={INFO.impalcatoArchi.drawerText}
        singleElementTitle={'arco'}
        tableWatch={mensoleTamponiCampateImpalcatoTableArchiTableWatch}
        tableWatchName={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable`}
        elementForm={
          <ArchiForm
            archiFields={
              mensoleTamponiCampateImpalcatoTableArchiTableWatch || []
            }
            selected={selected}
            setSelected={setSelected}
            archiTable={`mensoleTamponiCampateImpalcatoTable[${selectedIdx}].archiTable`}
            selectedIdx={selectedIdx}
          />
        }
        inspectionInfoForm={
          <InspectionInfoForm
            onSubmit={handleSaveInspection}
            onReset={handleResetInspection}
            tecnicoRilevatoreName={'l1t2a4_tecnicoRilevatoreArchi'}
            dateName={'l1t2a4_dataIspezioneArchi'}
            elementoCriticoStrutturaName={
              'l1t2a4_elementoCriticoStrutturaArchi'
            }
            elementoCriticoSismicaName={'l1t2a4_elementoCriticoSismicaArchi'}
            condizioneCriticaStrutturaName={
              'l1t2a4_condizioneCriticaStrutturaArchi'
            }
            condizioneCriticaSismicaName={
              'l1t2a4_condizioneCriticaSismicaArchi'
            }
            noteGeneraliName={'l1t2a4_noteGeneraliArchi'}
          />
        }
        tableConfig={dataArchiConfig}
        editRows={editRowsArchi}
        selected={selected}
        setSelected={setSelected}
        handleSelectAllClick={handleSelectAllClickArchi}
        drawerMediaIndex={drawerMediaIndex}
        setDrawerMediaIndex={setDrawerMediaIndex}
        schedaDifettiIndex={schedaDifettiIndex}
        setSchedaDifettiIndex={setSchedaDifettiIndex}
        open={open}
        setOpen={setOpen}
        openSchedaDifetti={openSchedaDifetti}
        setOpenSchedaDifetti={setOpenSchedaDifetti}
        copyTableConfig={copyTableConfig}
        copyType={'tipologiaArco'}
        tableForCopy={mensoleTamponiCampateToCopy}
      />
    </>
  );
};
ArchiSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default ArchiSection;
